module.exports = __webpack_public_path__ + "images/8a480fa4dcb888b1e9689b856c48e190.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/ksenia_square.jpg
// module id = 147
// module chunks = 24